import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

const KEY = "t";

export class Token {
  constructor(
    public token: string,
    public tokenType: string,
    public expiry: Date,
  ) {}
}

@Injectable()
export class Auth {
  set token(newToken) {
    const newTokenJson = JSON.stringify(newToken);
    localStorage.setItem(KEY, newTokenJson);
    sessionStorage.setItem(KEY, newTokenJson);

    this._token = newToken;
  }
  get token(): Token {
    if (!this._token) {
      this._token = Auth.getToken();
    }

    return this._token;
  }
  private _token: Token;

  public static getToken(): Token {
    /* Getting Details from Local Storage */
    let item = localStorage.getItem(KEY);
    /* Fallback to Session Storage */
    if (!item) {
      item = sessionStorage.getItem(KEY);
    }

    if (!item) {
      if (!environment.production) {
        item = environment.AUTH_TOKEN;
      } else {
        return null;
      }
    }

    try {
      const t = JSON.parse(item);
      const now = new Date().valueOf();

      if (t.expiry > now) {
        return t;
      }
    } catch (err) {
      return null;
    }

    return null;
  }

  loggedIn(): boolean {
    return !!this.token;
  }

  remove() {
    localStorage.removeItem(KEY);
    sessionStorage.removeItem(KEY);
    this._token = null;
  }
}
